import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=d578a9f8&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=d578a9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d578a9f8",
  null
  
)

export default component.exports